var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArchive extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.5847 3.3855C21.0325 3.3855 21.3955 3.74849 21.3955 4.19627V7.31781C21.3955 7.76384 21.0353 8.12575 20.59 8.12856C20.5882 8.12855 20.5865 8.12854 20.5847 8.12854H3.41626C3.41452 8.12854 3.41278 8.12855 3.41104 8.12856C2.96567 8.12574 2.60551 7.76383 2.60551 7.31781V4.19627C2.60551 3.74849 2.9685 3.3855 3.41628 3.3855H20.5847ZM2.66626 9.50414C1.75821 9.1927 1.10551 8.33148 1.10551 7.31781V4.19627C1.10551 2.92006 2.14007 1.8855 3.41628 1.8855H20.5847C21.8609 1.8855 22.8955 2.92006 22.8955 4.19627V7.31781C22.8955 8.33149 22.2428 9.19272 21.3347 9.50415V19.8039C21.3347 20.4168 21.0913 21.0045 20.6579 21.4379C20.2246 21.8712 19.6368 22.1147 19.024 22.1147H4.97703C4.36417 22.1147 3.77642 21.8712 3.34307 21.4379C2.90972 21.0045 2.66626 20.4168 2.66626 19.8039V9.50414ZM4.16626 9.62857V19.8039C4.16626 20.019 4.25168 20.2252 4.40373 20.3772C4.55578 20.5293 4.762 20.6147 4.97703 20.6147H19.024C19.239 20.6147 19.4452 20.5293 19.5973 20.3772C19.7493 20.2252 19.8347 20.019 19.8347 19.8039V9.62857H4.16626Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.90918 13.5608C8.90918 13.1466 9.24497 12.8108 9.65918 12.8108H14.3415C14.7557 12.8108 15.0915 13.1466 15.0915 13.5608C15.0915 13.975 14.7557 14.3108 14.3415 14.3108H9.65918C9.24497 14.3108 8.90918 13.975 8.90918 13.5608Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArchive.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArchive.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArchive.prototype, "size", void 0);
if (customElements.get('cat-icon-archive') === undefined) {
    customElements.define('cat-icon-archive', BlocksIconArchive);
}
